import { render, staticRenderFns } from "./SalesOpportunity.vue?vue&type=template&id=0b23286c&"
import script from "./SalesOpportunity.vue?vue&type=script&lang=js&"
export * from "./SalesOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./SalesOpportunity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesOpportunity.vue"
export default component.exports